import { makeStyles } from '@mui/styles';

const commonFormWrap = {
  display: 'flex',
  margin: '0.8rem'
};

export const useStyles = makeStyles((theme) => ({
  personalInfoContainer: {
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  fullWidth: {
    width: '100%'
  },
  contentTitleWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0.625rem 0 1rem 0',
  },
  treatmentTitleHeader: {
    margin: '1.2rem 0 0.2rem 0'
  },
  contentTitleLine: {
    width: '100%',
    height: 0,
    border: '1px solid #567282',
    display: 'inline-block',
    background: '#567282'
  },
  titleLine1: {
    margin: '4px 10px 0 26px',
  },
  titleLine2: {
    margin: '4px 26px 0 10px',
  },
  contentTitle: {
    color: theme.palette.primary.dark,
    fontSize: 20,
    fontWeight: '500',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down(370)]: {
      fontSize: 16,
    }
  },
  treatmentProviderLabel: {
    [theme.breakpoints.down(400)]: {
      letterSpacing: '-0.6px',
    }
  },
  treatmentCouncelorLabel: {
    [theme.breakpoints.down(420)]: {
      letterSpacing: '-1.1px',
    }
  },
  phyNamePhContainerStyle: commonFormWrap,
  phyNameContainerStyle: {
    marginRight: '1rem',
    minWidth: '57%'
  },
  phyAddrContainer: {
    margin: '0.8rem'
  },
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  checkboxText: {
    fontSize: 16,
    [theme.breakpoints.down(370)]: {
      fontSize: 12,
    }
  },
  treatmentProviderWrap: {
    marginTop: '0.5rem',
  },
  subTextColor: {
    color: theme.palette.primary.main
  },
  formPageNumber: {
    fontSize: 16,
    textAlign: 'right',
    padding: '0.5rem 0.75rem 0 0',
    [theme.breakpoints.down(370)]: {
      fontSize: 12,
    }
  },
  buttonsNavContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.5rem 1rem 1rem 1rem'
  },
  errorText: {
    color: theme.palette.error.main,
    fontSize: 14,
    margin: '2px 0 0 4px',
  },
  btnDisabled: {
    background: theme.palette.common.grey,
    color: '#9e9e9e',
    '&:hover': {
      background: theme.palette.common.grey,
      color: '#9e9e9e',
    }
  }
}));
